import * as React from "react";
import { ManufacturerAdminModel, ManufacturerFilterSettingsModel, ManufacturerGridModel } from "../../../models/manufacturer";
import ManufacturerList from './manufacturerList';
import ManufacturerService from '../../../services/manufacturerService';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import { ManufacturerFilter } from './manufacturerFilter';
import ManufacturerAddEditDialog from './manufacturerAddEditDialog';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { Lang } from '../../../common/enums';
import { ManufacturerContentModel } from '../../../models/manufacturer/manufacturerContentModel';

/*const MedicineAddEditLoadable = Loadable({
	loader: () => import('./manufacturersAddEditDialog'),
	loading: Spinner,
	delay: 1000, // 0.1 seconds
	timeout: 10000, // 10 seconds
});*/

interface IProps {
}

interface IState {
  manufacturers: Array<ManufacturerAdminModel>;
  isLoading: boolean;
  error: any;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleDialogWrap: boolean;
  isVisibleConfirmDialog: boolean;
  currentManufacturer: ManufacturerAdminModel;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  manufacturerSettings: ManufacturerFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 10;

class ManufacturerContainer extends React.Component<IProps, IState> {
  manufacturerService = new ManufacturerService();
  messages: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      manufacturers: new Array<ManufacturerAdminModel>(0),
      isLoading: false,
      isVisibleDialog: false,
      isVisibleDialogWrap: false,
      isVisibleConfirmDialog: false,
      currentManufacturer: new ManufacturerAdminModel(),
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      manufacturerSettings: new ManufacturerFilterSettingsModel()
    };
  }

  // events
  componentDidMount() {
    this.getAllManufacturers(this.state.from, this.state.numberOfRows);
  }

  // handles
  handleAddAndEditClick = id => {
    if (!id) { // Add			
      let manufacturer = new ManufacturerAdminModel();
      let contentList = new Array<ManufacturerContentModel>(0);
      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new ManufacturerContentModel();
        content.langId = parseInt(Lang[k]);
        content.name = '';
        content.city = '';
        content.country = '';
        content.address = '';
        contentList.push(content);
      });

      manufacturer.manufacturerContent = contentList;
      this.setcurrentManufacturer(manufacturer);
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true
      });
      this.manufacturerService.getManufacturer(id)
        .then(
          (data: ManufacturerAdminModel) => {
            this.setcurrentManufacturer(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.setState({
              error,
              isLoading: false
            });
          }
        );
    }
  };

  getManufacturer = (id) => {
    this.manufacturerService.getManufacturer(id)
      .then(
        (data: ManufacturerAdminModel) => {
          this.setcurrentManufacturer(data);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleDeleteClick = (id) => {
    this.getManufacturer(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteMedicine(id) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.manufacturerService.deleteManufacturer(id)
      .then(
        data => {
          this.getAllManufacturers(this.state.from, this.state.numberOfRows);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleSaveButton = (currentManufacturer: ManufacturerAdminModel) => {
    this.setState({
      isLoading: true
    });

    if (!currentManufacturer.manufacturerId) { // Add
      this.manufacturerService.addManufacturer(currentManufacturer)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentManufacturer(new ManufacturerAdminModel());
            this.getAllManufacturers(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentManufacturer(new ManufacturerAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.manufacturerService.editManufacturer(currentManufacturer.manufacturerId, currentManufacturer)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentManufacturer(new ManufacturerAdminModel());
            this.getAllManufacturers(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentManufacturer(new ManufacturerAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          });
    }
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  // methods
  getAllManufacturers(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.manufacturerService.getAllManufacturers(from, numberOfRows, this.state.manufacturerSettings).then(
      (data: ManufacturerGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          manufacturers: data.manufacturers,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  setcurrentManufacturer(medicine: ManufacturerAdminModel) {
    this.setState({ currentManufacturer: { ...medicine } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialogWrap: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleDialog: show
    }));
  };

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllManufacturers(startIndex, this.state.numberOfRows);
  }

  handleSearchButtonClick = (settings) => {
    this.setState({
      isLoading: true
    });

    this.manufacturerService.getAllManufacturers(initFrom, numberOfRows, settings).then(
      (data: ManufacturerGridModel) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          manufacturers: data.manufacturers,
          manufacturerSettings: settings,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  // render
  public render() {

    const { manufacturers, isLoading, error } = this.state;

    return (
      <div>

        <h3>Manufacturers</h3>

        {isLoading ? <Spinner /> : null}

        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        {this.state.isVisibleDialogWrap ? (
          <ManufacturerAddEditDialog
            saveClick={this.handleSaveButton}
            cancelClick={this.handleCancelButton}
            currentManufacturer={this.state.currentManufacturer}
            isVisible={this.state.isVisibleDialog}
          />
        ) : null}

        <div className="mb-2">
          <button
            onClick={() => this.handleAddAndEditClick(null)}
            className="btn btn-success"
            style={{ marginRight: "5px" }}>
            Add New
                </button>
        </div>

        <ManufacturerFilter
          onSearchClick={this.handleSearchButtonClick}
          totalRecordsCount={this.state.totalRecordsCount}
          isVisibleAlphabetic={true}
        />

        <ManufacturerList
          manufacturers={manufacturers}
          rows={numberOfRows}
          totalRecords={this.state.totalRecordsCount}
          onPageClick={this.handleOnPageClick}
          first={this.state.from}
          loading={Spinner}
          editClick={this.handleAddAndEditClick}
          deleteClick={this.handleDeleteClick}
        />

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteMedicine(this.state.currentManufacturer.manufacturerId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{this.state.currentManufacturer.name}"?
        </ConfirmDialog>
      </div>
    );
  }
}

export default ManufacturerContainer;